import React, { useEffect } from 'react';
import {
    Pagination,
    PaginationContent,
    PaginationFirst,
    PaginationItem,
    PaginationLast,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from "./ui/pagination";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "./ui/select";
import constants from '../commonUtils/constants';

const TanstackPagination = ({ table, data, pagination, handlePageChange, showEdgeNavigation = false }) => {

    useEffect(() => {
        table.setPageIndex(pagination.currentPage - 1);
    }, [pagination.currentPage, table]);


    const navPrev = () => {
        if (table.getCanPreviousPage()) {
            const newPage = pagination.currentPage - 1;
            handlePageChange(newPage, pagination.perPage);
        }
    };

    const navNext = () => {
        if (table.getCanNextPage()) {
            const newPage = pagination.currentPage + 1;
            handlePageChange(newPage, pagination.perPage);
        }
    };

    const navFirst = () => {
        if (pagination.currentPage !== 1) {
            handlePageChange(1, pagination.perPage);
        }
    };

    const navLast = () => {
        const lastPage = table.getPageCount();
        if (pagination.currentPage !== lastPage) {
            handlePageChange(lastPage, pagination.perPage);
        }
    };

    const handlePerPageChange = (value) => {
        handlePageChange(1, parseInt(value));
    };

    const renderPageLinks = () => {
        const totalPages = table.getPageCount();
        const currentPage = pagination.currentPage;
        const maxVisiblePages = 3;
        let startPage, endPage;

        if (totalPages <= maxVisiblePages) {
            // Total pages less than max visible pages, show all pages
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 2) {
                // Near the start
                startPage = 1;
                endPage = maxVisiblePages;
            } else if (currentPage + 1 >= totalPages) {
                // Near the end
                startPage = totalPages - maxVisiblePages + 1;
                endPage = totalPages;
            } else {
                // Somewhere in the middle
                startPage = currentPage - 1;
                endPage = currentPage + 1;
            }
        }

        const pageLinks = [];
        for (let i = startPage; i <= endPage; i++) {
            const isActive = i === currentPage;
            pageLinks.push(
                <PaginationItem key={i}>
                    <PaginationLink
                        href="#"
                        onClick={() => handlePageChange(i, pagination.perPage)}
                        className={isActive ? 'bg-primary text-white hover:bg-primary hover:text-white' : ''}
                    >
                        {i}
                    </PaginationLink>
                </PaginationItem>
            );
        }

        return pageLinks;
    };

    return (
        <div className='flex justify-end w-full'>
            <div className='flex gap-4 mt-4'>
                <div className='flex gap-2 justify-center items-center'>
                    <div className='inline-block whitespace-nowrap'>Per page: </div>
                    <Select defaultValue={pagination?.perPage?.toString()} onValueChange={handlePerPageChange}>
                        <SelectTrigger className="w-[60px]">
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                            {constants.tableUI.perPageOptions.map(option => (
                                <SelectItem key={option} value={option.toString()}>{option}</SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
                <Pagination>
                    <PaginationContent>
                        {showEdgeNavigation && (
                            <PaginationItem>
                                <PaginationFirst href="#" onClick={navFirst} disabled={pagination.currentPage === 1} />
                            </PaginationItem>
                        )}
                        <PaginationItem>
                            <PaginationPrevious href="#" onClick={navPrev} disabled={!table.getCanPreviousPage() && data?.length === 0} />
                        </PaginationItem>
                        {renderPageLinks()}
                        {table.getPageCount() > 3 && <PaginationItem>
                            {/* <PaginationEllipsis /> */}
                        </PaginationItem>}
                        <PaginationItem>
                            <PaginationNext href="#" onClick={navNext} disabled={!table.getCanNextPage() && data?.length === 0} />
                        </PaginationItem>
                        {showEdgeNavigation && (
                            <PaginationItem>
                                <PaginationLast href="#" onClick={navLast} disabled={pagination.currentPage === table.getPageCount() || table.getPageCount() === 0} />
                            </PaginationItem>
                        )}
                    </PaginationContent>
                </Pagination>
            </div>
        </div>
    );
}

export default TanstackPagination;
